export const PAGBANK_ONIX = ['7487', '7068', '7067', '7066', '5142', '7976', '7977'];
export const isPagBankOnix = (onixCode: string | null = ''): boolean =>
  PAGBANK_ONIX.includes(onixCode?.toString() || '');
